import { BaseService } from "../../core/baseService";
import {
  MenuCategoryServiceInterface,
  CreateMenuCategoryParams,
  UpdateMenuCategoryParams,
  DeleteMenuCategoryParams,
  BatchUpdateCategoryOrdersParams,
} from "../types/menu.types";
import { MenuCategory } from "../../../models/MenuCategory";
import { ApiResult } from "../../core/types";

export class MenuCategoryService
  extends BaseService
  implements MenuCategoryServiceInterface
{
  async getCategories(): Promise<ApiResult<MenuCategory[]>> {
    return this.handleRequest<MenuCategory[]>(
      this.client.get("/api/admin/menu/categories"),
    );
  }

  async createCategory(
    params: CreateMenuCategoryParams,
  ): Promise<ApiResult<MenuCategory>> {
    const createData = {
      ...params,
      translations: params.translations || [],
    };
    return this.handleRequest<MenuCategory>(
      this.client.post("/api/admin/menu/categories", createData),
    );
  }

  async updateCategory(
    params: UpdateMenuCategoryParams,
  ): Promise<ApiResult<MenuCategory>> {
    const { categoryId, ...updateData } = params;

    const data = {
      ...updateData,
      translations: params.translations || [],
    };

    return this.handleRequest<MenuCategory>(
      this.client.put(`/api/admin/menu/categories/${categoryId}`, data),
    );
  }

  async deleteCategory(
    params: DeleteMenuCategoryParams,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/menu/categories/${params.categoryId}`),
    );
  }

  async batchUpdateCategoryOrders(
    params: BatchUpdateCategoryOrdersParams,
  ): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.put(
        "/api/admin/menu/categories/batch-update-order",
        params.updates,
      ),
    );
  }
}
